'use strict';
import { BaseService } from '@narrate/base-sdk';

const OPTIONS = {
};

const VALIDATIONS = {
};

/**
 * uses attributes api to store and retrieve the user account
 *
 * future work:
 *  may handle conflict resolution
 *
 * @example
 *    // using CoreService (recommended)
 *    import Core from '@narrate/core-sdk';
 *
 *    const { value: account } = await Core.api.account.get();
 *    console.log(account); // should be something like { birthdate: }
 *
 *    await Core.api.account.save({ videos: [] });
 */
class AccountService extends BaseService {

  constructor() {
    super({ configPath: 'services.account' });
  }


  // [HQT] 12/23 commented out -- is not used. May return to this when we implement account settings etc.
  // find = async () => {
  //   return await this.requestRootResource();
  // }

  // save = async (account) => {
  //   return await this.requestRootResource({
  //     method: 'post',
  //     data: account,
  //   });
  // }

  /**
   * The authenticated user account saved payment methods on stripe.
   * 
   * USAGE NOTE: the remote config add pends the 'action' query parameter as action=list
   * @return {object} - { paymentMethods: [{paymentInfo}...]}, where each paymentInfo has attributes:
   *    id - payment id
   *    customerId - stripe customer
   *    cardType - visa/mastercard
   *    month: - 1..12
   *    year: 4 digit string
   *    lastFour: string
   */
  paymentMethods = async () => {
    return await this.requestResource('paymentMethods');
  };

  /**
   * The authenticated user account saved preferred(default) payment method.
   * USAGE NOTE: the remote config add pends the 'action' query parameter as action=preferred
   * @return {object} - @see return for paymentMethods. Behind the scenes this is one API call. So the map of array with one object is returned.
   */
  preferredPaymentMethod = async () => {
    return await this.requestResource('preferredPaymentMethods');
  }
}

AccountService.OPTIONS = OPTIONS;

export default AccountService;
